import styled from 'styled-components/macro';
import { Checkbox } from '@yme/atoms/checkbox';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const RegularTextLevel3Styled = styled(RegularTextLevel3) `
  margin-left: 4px;
  margin-right: 4px;
`;
export const CheckboxStyled = styled(Checkbox) `
  min-width: 24px;
`;
